import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-stale-date-range-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe],
  template: `
    <div class="flex flex-col gap-3 p-5">
      <p class="m-0 font-hp-sans text-[12px] leading-5 text-hp-ink">
        This page was restored with older time selection, not the latest data.
      </p>

      <div
        class="flex flex-col gap-1.5 rounded-lg border bg-hp-panel px-3 py-2.5"
        style="border-color: var(--hp-hair)"
      >
        @if (from) {
          <div class="flex items-center justify-between gap-4">
            <span class="font-hp-sans text-[10px] uppercase tracking-[0.6px] text-hp-muted2">
              From
            </span>
            <span class="font-hp-mono text-[11px] text-hp-ink">
              {{ from | date: 'yyyy-MM-dd HH:mm' }}
            </span>
          </div>
        }

        <div class="flex items-center justify-between gap-4">
          <span class="font-hp-sans text-[10px] uppercase tracking-[0.6px] text-hp-muted2">
            Selected time
          </span>
          <span class="font-hp-mono text-[11px] text-hp-ink">
            {{ to | date: 'yyyy-MM-dd HH:mm' }}
          </span>
        </div>

        <div class="flex items-center justify-between gap-4">
          <span class="font-hp-sans text-[10px] uppercase tracking-[0.6px] text-hp-muted2">
            Latest available
          </span>
          <span class="font-hp-mono text-[11px] text-hp-ink">
            {{ latest | date: 'yyyy-MM-dd HH:mm' }}
          </span>
        </div>
      </div>
    </div>
  `,
})
export class StaleDateRangeDialogComponent {
  @Input() from?: Date;
  @Input() to!: Date;
  @Input() latest!: Date;
}
